import { BaseAccessPropertiesRequestClass } from "../general/base-access-properties-request.class";
import { BuilderDocumentModel } from "./builder-document.model";
import { BuilderActorModel } from "./builder-actor.model";
import { BuilderSendGroupModel } from "./builder-sendgroup.model";
import { BuilderRequestAutoExportSettingsModel } from "./builder-request-auto-export-settings.model";
import CloudItem from "../clouditem";

/**
 * Main Builder (Request) model
 */
export class BuilderRequestModel extends BaseAccessPropertiesRequestClass {

    /**
     * (Guid) Identifier
     */
    id: string = "";
    /**
     * Name of the request
     */
    requestName: string = "";
    /**
     * What workflow is being used to Build this request
     */
    workflowId?: string | null = null;
    /**
     * Type of Request
     */
    dossierType: string = "";
    /**
     * (Current) status of the request
     */
    status: string = "";
    /**
     * A guid representing the unique identifier of a workgroup
     */
    workgroup: string = "";

    // FRONTEND ONLY PROPERTIES:
    //---------------------------
    /**
     * FRONTEND ONLY PROPERTY
     * Stores the Matched WorkgroupName for the associated workGroup(Guid)
     * 
     */
    workgroupName: string | null = null;

    /**
     * Holds the ConversionError if triggered, linked to request but associated with the error document
     */
    conversionError: string | null = null;
    /**
     * Marks whether invalid filing data (XBRI) has been read
     */
    hasInvalidFilingData: boolean = false;
    /**
     * Marks whether the uploaded XBRI package carried its own KvK 'deponeringsgegevens' file, so the filing
     * data was read out of that file
     */
    kvkFileFromPackage: boolean = false;
    /**
     * Marks whether the filing data (XBRI) carries an adoption date that no Adopt action chose
     */
    hasPrefilledAdoptionDate: boolean = false;

    /**
     * Uploaded documents
     */
    documentInfo: BuilderDocumentModel[] = [];

    /**
     * Created/Assigned Persons
     */
    dossierPersons: BuilderActorModel[] = [];

    /**
     * Created/Assigned Actors/Actions
     */
    actors: BuilderActorModel[] = [];

    /**
     * SendGroups
     */
    builderSendgroups: BuilderSendGroupModel[] = [];

    /**
     * If auto export set, to where:
     */
    autoExportModel: BuilderRequestAutoExportSettingsModel | null = null;


}
